<template>
  <div class="text-center py-4">
    <router-link class="nav-link" :to="{ name: 'index' }">
      <img width="150" height="28" src="@/assets/images/logo.svg">
    </router-link>
  </div>
</template>
